<template>
  <v-container fluid class="batchdeposit-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-deposit`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Deposit
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab-item :value="'tab-deposit'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Deposit</p>
                      <v-select
                        readonly
                        class="mb-4"
                        :items="deposittype"
                        v-model="edit_deposit.deposittype"
                        v-on:change="onChangeBatchDeposit($event, 'deposittype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the deposit type"
                      >
                      </v-select>
                      <v-menu
                        ref="menu_depositdate"
                        v-model="menu_depositdate"
                        :close-on-content-click="false"
                        :return-value.sync="depositdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="depositdate"
                            label="Deposit Date"
                            v-bind="attrs"
                            v-bind:value="depositdate"
                            v-on:change="
                              onChangeBatchDeposit($event, 'depositdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the deposit date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="depositdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_depositdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeBatchDeposit(
                                depositdate,
                                'depositdate'
                              );
                              $refs.menu_depositdate.save(depositdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-switch
                        color="primary"
                        v-on:change="onChangeBatchDeposit($event, 'isTaxable')"
                        v-model="edit_deposit.isTaxable"
                        v-bind:value="edit_deposit ? edit_deposit.isTaxable : false"
                        hint="Taxable"
                        persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="data_accounts"
                        v-model="edit_deposit.accountid"
                        v-on:change="onChangeBatchDeposit($event, 'accountid')"
                        v-bind:error="errorindex == 2"
                        outlined
                        dense
                        placeholder="Account"
                        persistent-hint
                        single-line hint="Please choose the account">
                      </v-select>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="edit_deposit.locationid"
                        v-on:change="onChangeBatchDeposit($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-model="edit_deposit.refnum"
                        v-on:change="onChangeBatchDeposit($event, 'refnum')"
                        outlined
                        dense
                        placeholder="Reference Num"
                        persistent-hint
                        single-line hint="Enter the reference or description">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Pending', 'Approved', 'Completed']"
                        v-model="edit_deposit.depositstatus"
                        v-on:change="onChangeBatchDeposit($event, 'depositstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/batchdeposit/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateBatchDeposit()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      v-show="isEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; new_transaction={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/batchdeposit/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                        :headers="header_items"
                        :items="data_transactions"
                        :items-per-page="100"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ `${delete_transaction.transclass}: ${delete_transaction.transtype} ${delete_transaction.transnum}`  }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.transimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.transimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.transimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.transtype="{ item }">
                          {{ item.transclass=='Discount' ? `${item.transclass}:` : '' }} {{ item.transtype }} {{ item.transnum }}
                        </template>
                        <template v-slot:item.transamount="{ item }">
                          <p v-if="item.transclass=='Discount'" class='two-line'>{{ item.transdiscount!=null ? `${ (0-item.transdiscount).toFixed(2) }` : 0 }}</p>
                          <p v-else class='two-line'>{{ item.transamount!=null ? item.transamount.toFixed(2) : 0 }}</p>
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="editTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="['Deposit', 'Discount']"
                    v-model="new_transaction.transclass"
                    v-on:change="onSelectClass($event)"
                    dense
                    outlined
                    placeholder="Class"
                    persistent-hint
                    single-line
                    hint="Please choose the class"
                    >
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    :readonly="isNotEditable"
                    class="mb-4"
                    :items="data_salesorders.map(x => {return {text: `${x.salesordertype} ${x.salesordernum}`, value: x._id};})"
                    v-model="new_transaction.salesorderid"
                    v-on:change="onSelectSalesOrder($event)"
                    outlined
                    dense
                    placeholder="Sales Order"
                    persistent-hint
                    single-line hint="Please choose the order">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="new_transaction.transname"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Name"
                    persistent-hint
                    single-line hint="Name">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" v-if="isDeposit==true">
                  <v-text-field
                    v-if="isDeposit==true"
                    type="number"
                    v-model="new_transaction.transamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Deposit Amount"
                    persistent-hint
                    single-line hint="Deposit Amount">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" v-if="isDiscount==true">
                  <v-text-field
                    v-if="isDiscount==true"
                    type="number"
                    v-model="new_transaction.transdiscount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Discount"
                    persistent-hint
                    single-line hint="Discount">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" v-if="isDeposit==true">
                  <v-text-field
                    readonly
                    type="number"
                    v-model="new_transaction.transtotal"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Order Total"
                    persistent-hint
                    single-line hint="Order Total">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; new_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    readonly
                    class="mb-4"
                    :items="['Deposit', 'Discount']"
                    v-bind:value="`${edit_transaction.transclass}`"
                    dense
                    outlined
                    placeholder="Class"
                    persistent-hint
                    single-line
                    hint="Class"
                    >
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-bind:value="`${edit_transaction.transtype} ${edit_transaction.transnum}`"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Type">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-bind:value="`${edit_transaction.transname}`"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Name"
                    persistent-hint
                    single-line hint="Name">
                  </v-text-field>
                </v-col>
                <v-col v-if="edit_transaction.transclass=='Discount'" cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.transdiscount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Discount"
                    persistent-hint
                    single-line hint="Discount">
                  </v-text-field>
                </v-col>
                <v-col v-else cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.transamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Deposit Amount"
                    persistent-hint
                    single-line hint="Deposit Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";
import { sortDataDsc } from '@/util/tools';

export default {
  data() {
    return {
      header_items: [
        { text: 'Date', value: 'transdate', width: '10%'},
        { text: 'Type', value: 'transtype', width: '20%'},
        { text: 'Name', value: 'transname'},
        { text: 'Amount', value: 'transamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],
      classes: ['Cost of Good Sold', 'Administrative Expense', 'Operating Expense', 'Marketing Expense', 'Tax & Financing Expense', 'Factory & Production Expense', 'Debt & Loan', 'Overhead'],
      change_deposit: {},
      edit_deposit: {},
      
      deletefile: {},
      searchvendor: {},
      initvalue: {},
      edit_transaction: {},
      new_transaction: {},
      delete_transaction: {},

      deposittype: ["Batch Deposit"],
      transactions: [],
      data_salesorders: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      route: 0,

      menu_transdate: false,
      menu_transdate_edit: false,
      
      accountsubclass: null,
      accountsubclass2: null,

      depositdate: null,
      depositduedate: null,
      menu_depositdate: false,
      menu_depositduedate: false,

      isEditTransaction: false,
      isAddTransaction: false,
      isDeleteFile: false,
      isDeleteTransaction: false,
      isDeposit: false,
      isDiscount: false,    
      errorindex: undefined,
    };
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("BatchDeposit", ["isReceiving"]),
    ...mapState("Department", ["departments"]),
    ...mapState("Item", ["items"]),
    ...mapState("Location", ["locations"]),
    ...mapState("User", ["users"]),
    ...mapState("Vendor", ["vendors"]),
    data_accounts(){
      let result = this.accounts.filter(account=>account.accountsubclass=='Bank');
      let filter = this.accounts.filter(account=>account.accountname.includes('Advance') || account.accountname.includes('Prepayment'));
      let results = [...result, ...filter];
      return results.map(x => { return {text: x.accountname, value: x._id} });
    },
    data_transactions(){
      let result =  [];
      result = [...result, ...this.transactions.filter(i=>i.transclass=='Deposit' || i.transclass==null)];
      result = [...result, ...this.transactions.filter(i=>i.transclass=='Discount')];
      return result;
    },
    isNotEditable(){
      let result = ['New','Credit','Partial','Pending','Audit','Void'].indexOf(this.initvalue.depositstatus) == -1;
      return result;
    },
    isEditable(){
      let result = ['New','Partial', 'Audit', 'Void'].indexOf(this.initvalue.depositstatus) >= 0;
      return result;
    }
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("BatchDeposit", ["deleteBatchDepositTransactionRequest", "getBatchDepositRequest", "insertBatchDepositTransactionRequest", "updateBatchDepositRequest", "updateBatchDepositTransaction"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("SalesOrder", ["getSalesOrdersStatusRequest"]),
    ...mapActions("User", ["getUsersRequest"]),
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.salesorderid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.transamount && this.new_transaction.transclass=='Deposit'){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      if(!this.new_transaction.transdiscount && this.new_transaction.transclass=='Discount'){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, transname: item.transname, transtype: item.transtype, transnum: item.transnum, transclass: item.transclass};
    },
    async deleteTransaction(item) {
      this.isDeleteTransaction = false; 
      let response = await this.deleteBatchDepositTransactionRequest(item);
      let index = this.transactions.findIndex((trans)=>trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getBatchDepositRequest(this.initvalue._id);
    },
    async insertTransaction() {
      if(!this.checkTransaction()) return;
      let payload = Object.assign({depositid: this.initvalue._id}, this.new_transaction);
      let result = await this.insertBatchDepositTransactionRequest(payload);
      result.id = result._id;
      this.transactions.push(result);
      this.getBatchDepositRequest(this.initvalue._id);
      this.clearTransaction();
      this.isAddTransaction = false;
    },
    editTransactionDialog(item) {
      console.log(item);
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    onChangeBatchDeposit(value, field) {
      this.change_deposit[field] = value;
    },
    onSelectSalesOrder(id) {
      let find = this.data_salesorders.find(i=>i._id==id);
      if(find==null) this.new_transaction.salesorderid = null;
      else {
        this.new_transaction.salesorderid = find._id;
        this.new_transaction.customerid = find.customerid;
        this.new_transaction.refnum = find.refnum;
        this.new_transaction.transtype = find.salesordertype;
        this.new_transaction.transnum = find.salesordernum;
        this.new_transaction.transimage = find.salesorderimage;
        this.new_transaction.transname = find.salesordername;
        this.new_transaction.transamount = 0;
        this.new_transaction.transtotal = find.salesordertotal.toFixed(2);
      }
      this.onSelectClass(this.new_transaction.transclass);
    },
    onSelectClass(value) {
      let update = {transamount: null, transdiscount: null};
      if(value=='Deposit') {
        update.transamount = 0;
        this.isDeposit = true;
        this.isDiscount = false;
      }
      else if (value=='Discount'){
        update.transdiscount = 0;
        this.isDeposit = false;
        this.isDiscount = true;
      }
      
      this.new_transaction = Object.assign({},this.new_transaction, update);
      console.log('select', this.new_transaction);
    },
    async updateBatchDeposit() {
      this.change_deposit._id = this.initvalue._id;
      await this.updateBatchDepositRequest(this.change_deposit);
      router.push("/batchdeposit/list");
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let json = {_id: this.edit_transaction._id, transamount: this.edit_transaction.transamount, transdiscount: this.edit_transaction.transdiscount};
      let response = await this.updateBatchDepositTransaction(json);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.clearTransaction();
      this.getBatchDepositRequest(this.initvalue._id);
    },
  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "BatchDepositList" });
    this.edit_deposit = Object.assign({}, this.initvalue);
    this.depositdate = formatStdDate(this.initvalue.depositdate);

    let result = await this.getBatchDepositRequest(this.initvalue._id);
    this.transactions = Object.assign([], result.transactions);
    
    if (this.accounts.length==0) await this.getAccountsRequest();
    if (this.locations.length==0) await this.getLocationsRequest();
    if (this.users.length==0) await this.getUsersRequest();
    
    let orders_new = await this.getSalesOrdersStatusRequest('New');
    let orders_credit = await this.getSalesOrdersStatusRequest('Credit');
    let orders_partial = await this.getSalesOrdersStatusRequest('Partial');
    let orders_pending = await this.getSalesOrdersStatusRequest('Pending');
    this.data_salesorders = [...orders_new, ...orders_credit, ...orders_partial, ...orders_pending];
    sortDataDsc(this.data_salesorders, 'salesordernum');
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
